var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"c-toast-container",attrs:{"name":"fade","tag":"div"}},_vm._l((_vm.toasts),function(toast){return _c('c-toast',{key:toast.id,attrs:{"toast":toast}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }